module.exports = __webpack_public_path__ + "media/markers/marina_grn-0544e69c.svg";